import {
  CLEAR_DATE_TIME,
  DATES_LOADING_FAILED,
  DATES_LOADING_SUCCESS,
  SELECT_DATE,
  SELECT_DAY,
  SELECT_SLOT,
  SELECT_TIME,
} from "./types";
import { DATES_LOADING_ADDRESS } from "../../variables";
import { hideDatesLoader, showDatesLoader } from "./loaderActions";
import { setErrorPanel } from "./panelsActions";
import store from "../store";
import { getValidDatesForQueue } from "../../helpers/getValidDatesForQueue";
import Api from "../../api";
import { HealthCheckEvents } from "../../api/types";
import { parceErrorData, throwErrorMessageFromResponse } from "../../helpers/redux";

export const startDatesLoading =
  (
    selectedMedicalOrganisation,
    selectedDoctorName,
    selectedDoctorSpeciality,
    sessionId,
    startDate,
    endDate,
    orderId
  ) =>
  (dispatch) => {
    const healthCheckInstance = Api.healthCheckFor(HealthCheckEvents.getSlotList);
    const data = {
      "organizationId": [selectedMedicalOrganisation.MO_Id],
      "caseNumber": String(orderId),
      "serviceId": [selectedDoctorSpeciality.Service_Id],
      "eserviceId": "10000103595",
      attributes: [
        {
          name: "Session_Id",
          value: sessionId,
        },
        {
          name: "Resource_Id",
          value: selectedDoctorName.Resource_Id,
        },
        {
          name: "MO_Id",
          value: selectedMedicalOrganisation.MO_Id,
        },
        {
          name: "Startdate",
          value: startDate,
        },
        {
          name: "Enddate",
          value: endDate,
        },
        {
          name: "Starttime",
          value: "00:00",
        },
        {
          name: "Endtime",
          value: "23:59",
        },
        {
          "name": "Service_Id",
          "value": selectedDoctorSpeciality.Service_Id
        }
      ],
    };
    dispatch(showDatesLoader());
    let config = {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      timeout: 40_000
    };

    Api.instance
      .post(DATES_LOADING_ADDRESS, data, config)
      .then((response) => {
        throwErrorMessageFromResponse(response);

        const exceptions = store.getState().equeues.exceptions;
        const slots = response.data.slots.filter(
          (slot, index, self) =>
            index ===
            self.findIndex((t) => t.visitTimeStr === slot.visitTimeStr)
        );
        const slotsStore = getValidDatesForQueue(slots, exceptions);

        dispatch(datesLoadingSuccess(slotsStore));

        healthCheckInstance.sendSuccess();
      })
      .catch((error) => {
        const [errorMessage, isCustom] = parceErrorData(error);
        healthCheckInstance.sendFailure({ browserError: error.message });
        dispatch(datesLoadingFailed({
          errorDetail: {
            errorMessage: errorMessage
          }
        }));
        dispatch(setErrorPanel(errorMessage, isCustom));
      })
      .finally(() => dispatch(hideDatesLoader()));
  };

export const datesLoadingSuccess = (dates) => {
  return {
    type: DATES_LOADING_SUCCESS,
    payload: dates,
  };
};

export const datesLoadingFailed = (error) => {
  return {
    type: DATES_LOADING_FAILED,
    payload: {
      error,
    },
  };
};
export const selectDate = (date) => {
  return {
    type: SELECT_DATE,
    payload: date,
  };
};

export const selectDay = (day) => {
  return {
    type: SELECT_DAY,
    payload: day,
  };
};

export const selectTime = (time) => {
  return {
    type: SELECT_TIME,
    payload: time,
  };
};

export const selectSlot = (slot) => {
  return {
    type: SELECT_SLOT,
    payload: slot,
  };
};

export const clearDateTime = () => {
  return {
    type: CLEAR_DATE_TIME,
  };
};
